import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef, NbGlobalLogicalPosition, NbToastrService } from '@nebular/theme';
import { AnalistaDataService } from '../../../../../../../services/v1/AnalistaController/analista-data.service';
import { CriarCompromissoSignature } from '../../../../../../shared/Signature/CriarCompromissoSignature';
import { AtualizarCompromissoSignature } from '../../../../../../shared/Signature/AtualizarCompromissoSignature';

@Component({
  selector: 'ngx-modal-compromisso-customizado',
  templateUrl: './modal-compromisso-customizado.component.html',
  styleUrls: ['./modal-compromisso-customizado.component.scss']
})
export class ModalCompromissoCustomizadoComponent implements OnInit {
  @Input() compromisso: any = null;
  @Input() dataSelecionada: Date = new Date();
  @Input() modoEdicao: boolean = false;

  logicalPositions = NbGlobalLogicalPosition;
  
  titulo: string = '';
  descricao: string = '';
  dataCompromisso: Date = new Date();
  dataCompromissoFormatada: string = '';
  horaCompromisso: string = '12:00';
  
  carregando: boolean = false;

  constructor(
    public dialogRef: NbDialogRef<ModalCompromissoCustomizadoComponent>,
    private analistaService: AnalistaDataService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit(): void {
    if (this.modoEdicao && this.compromisso) {
      this.titulo = this.compromisso.titulo || '';
      this.descricao = this.compromisso.descricao || '';
      
      if (this.compromisso.data_compromisso) {
        const dataCompromisso = new Date(this.compromisso.data_compromisso);
        this.dataCompromisso = dataCompromisso;
        this.dataCompromissoFormatada = this.formatarDataParaInput(dataCompromisso);
        this.horaCompromisso = this.formatarHora(dataCompromisso);
      }
    } else {
      this.dataCompromisso = this.dataSelecionada;
      this.dataCompromissoFormatada = this.formatarDataParaInput(this.dataSelecionada);
    }
  }

  formatarHora(data: Date): string {
    const horas = data.getHours().toString().padStart(2, '0');
    const minutos = data.getMinutes().toString().padStart(2, '0');
    return `${horas}:${minutos}`;
  }

  formatarDataParaInput(data: Date): string {
    const ano = data.getFullYear();
    const mes = (data.getMonth() + 1).toString().padStart(2, '0');
    const dia = data.getDate().toString().padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  }

  combinarDataHora(): Date {
    const [horas, minutos] = this.horaCompromisso.split(':').map(Number);
    const [ano, mes, dia] = this.dataCompromissoFormatada.split('-').map(Number);
    const dataCompleta = new Date(ano, mes - 1, dia, horas, minutos, 0, 0);
    return dataCompleta;
  }

  salvar(): void {
    if (!this.validarFormulario()) {
      return;
    }

    this.carregando = true;
    const dataCompleta = this.combinarDataHora();

    if (this.modoEdicao) {
      this.atualizarCompromisso(dataCompleta);
    } else {
      this.criarCompromisso(dataCompleta);
    }
  }

  criarCompromisso(dataCompleta: Date): void {
    const signature = new CriarCompromissoSignature({
      titulo: this.titulo,
      descricao: this.descricao,
      data_compromisso: dataCompleta,
      metadata: JSON.stringify({ tipo: 'customizado' })
    });
    this.analistaService.CriarCompromisso(signature).subscribe(
      response => {
        this.carregando = false;
        if (response.success) {
          this.toastrService.success('Compromisso criado com sucesso!', 'Sucesso', {
            position: NbGlobalLogicalPosition.TOP_END
          });
          this.dialogRef.close({ success: true, action: 'create', data: response.data });
        } else {
          this.toastrService.danger(response.message || 'Erro ao criar compromisso', 'Erro', {
            position: NbGlobalLogicalPosition.TOP_END
          });
        }
      },
      error => {
        this.carregando = false;
        console.error('Erro ao criar compromisso:', error);
        this.toastrService.danger('Erro ao criar compromisso', 'Erro', {
          position: NbGlobalLogicalPosition.TOP_END
        });
      }
    );
  }

  atualizarCompromisso(dataCompleta: Date): void {
    const signature = new AtualizarCompromissoSignature({
      id: this.compromisso.id,
      titulo: this.titulo,
      descricao: this.descricao,
      data_compromisso: dataCompleta,
      metadata: this.compromisso.metadata
    });

    this.analistaService.AtualizarCompromisso(signature).subscribe(
      response => {
        this.carregando = false;
        if (response.Success) {
          this.toastrService.success('Compromisso atualizado com sucesso!', 'Sucesso', {
            position: NbGlobalLogicalPosition.TOP_END
          });
          this.dialogRef.close({ success: true, action: 'update', data: signature });
        } else {
          this.toastrService.danger(response.message || 'Erro ao atualizar compromisso', 'Erro', {
            position: NbGlobalLogicalPosition.TOP_END
          });
        }
      },
      error => {
        this.carregando = false;
        console.error('Erro ao atualizar compromisso:', error);
        this.toastrService.danger('Erro ao atualizar compromisso', 'Erro', {
          position: NbGlobalLogicalPosition.TOP_END
        });
      }
    );
  }



  validarFormulario(): boolean {
    if (!this.titulo.trim()) {
      this.toastrService.warning('Título é obrigatório', 'Atenção', {
        position: NbGlobalLogicalPosition.TOP_END
      });
      return false;
    }

    if (!this.descricao.trim()) {
      this.toastrService.warning('Descrição é obrigatória', 'Atenção', {
        position: NbGlobalLogicalPosition.TOP_END
      });
      return false;
    }

    if (!this.dataCompromissoFormatada) {
      this.toastrService.warning('Data do compromisso é obrigatória', 'Atenção', {
        position: NbGlobalLogicalPosition.TOP_END
      });
      return false;
    }

    return true;
  }

  fechar(): void {
    this.dialogRef.close({ success: false });
  }
} 